import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IonicModule } from '@ionic/angular';

import { ValidationInputComponent } from './validation-input.component';

@NgModule({
    imports: [
        CommonModule,
        IonicModule
    ],
    declarations: [
        ValidationInputComponent
    ],
    exports: [
        ValidationInputComponent
    ]
})
export class ValidationInputComponentModule { }
